import { useGetMemberTraitsQuery } from "@apis/traits/useTraits"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import {
  traitsIconParser,
  parseLucideTraitIcon,
  iconColorClass,
} from "./traitsIconParser"
import { cn } from "@components/ui/lib/utils"
import { Loader2 } from "lucide-react"
import { DynamicIcon } from "lucide-react/dynamic"

type TTraitsProps = {
  prospect_guid: string
}

const Traits = ({ prospect_guid }: TTraitsProps) => {
  const {
    data: memberTraits,
    isError,
    error,
    isPending,
  } = useGetMemberTraitsQuery(prospect_guid)

  if (isPending) {
    return (
      <Loader2 className="tw:h-6 tw:w-6 tw:animate-spin tw:text-gray-500" />
    )
  }

  if (isError) {
    return (
      <div className="tw:text-red-500">
        There was an error loading member traits. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-wrap tw:gap-2 tw:py-2">
      {memberTraits?.map((trait) => {
        const lucideName = parseLucideTraitIcon(trait.lucide_trait_icon)
        const Icon = lucideName ? null : traitsIconParser(trait.trait_icon)
        if (!lucideName && !Icon) return null

        const iconClassName = cn(
          "tw:h-8 tw:w-8",
          iconColorClass(lucideName ? trait.trait_style : trait.trait_icon),
        )

        return (
          <Tooltip key={`${trait.trait_description}`}>
            <TooltipTrigger>
              {lucideName ? (
                <DynamicIcon name={lucideName} className={iconClassName} />
              ) : (
                Icon && <Icon className={iconClassName} />
              )}
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <span>{trait.trait_description}</span>
            </TooltipContent>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default Traits
